export default "__VITE_PUBLIC_ASSET__00e377fa__"